import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const productApi = {
    assignCustomersToPlusMembershipOffer: async (offerID, customerFile, removeCustomers) => {
        const formData = new FormData();
        formData.append('offerID', offerID);
        formData.append('removeCustomers', removeCustomers);
        formData.append('customerFile', customerFile);

        const url = `api/plus-membership-offers-customer-map/v1/customers`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    bulkUploadDriverTipsSettings: async (data) => {
        const formData = new FormData();
        formData.append('driverTipsSettingsFile', data.file);

        const url = `api/product/v1/driverTipsSettings`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    createFeatureFlag: async (item) => {
        const url = `api/product/v1/featureFlag`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    confirmUploadDriverTipsSettings: async (key) => {
        const url = 'api/product/v1/driverTipsSettings/confirmUpload';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    downloadPlusMembershipOfferCustomerCSV: async (offerID) => {
        const url = `api/plus-membership-offers-customer-map/v1/customers/csv?offerID=${offerID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                await fileDownload(
                    res,
                    `PlusMembershipOffer${offerID}Customers-${new Date().toISOString().slice(0, 19).replace('/[:_-]/g', '').replace(/[T]/g, '-')}.csv`,
                );
            }
        } catch (e) {
            logError(e);
        }
    },
    getAssignableFeatureFlags: async () => {
        const url = `api/product/v1/featureFlag/assignable`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getDriverTipsSettings: async () => {
        const url = `api/product/v1/driverTipsSettings`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getFeatureFlagCustomers: async () => {
        const url = `api/product/v1/featureFlag/customers`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getFeatureFlags: async () => {
        const url = `api/product/v1/featureFlag`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getFacilityInFeature: async (feature, facilityID) => {
        const url = `api/product/v1/featureFlag/facilityInFeature?feature=${feature}&facilityId=${facilityID}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    },
    getIsFeatureOn: async (feature, { signal } = {}) => {
        const url = `api/product/v1/featureFlag/isFeatureOn?feature=${feature}`;
        return mmFetchWithResponse(url, { method: 'GET', signal });
    },
    getPlusMembershipOffers: async () => {
        const url = `api/plus-membership-offers/v1/offers`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    createPlusMembershipOffer: async (formData) => {
        const sendParams = {
            credits: formData.creditsValue,
            creditsDurationDays: formData.creditsDurationDays,
            name: formData.name,
            offerType: formData.offerType,
            discountType: formData.discountType,
            discountAmount: formData.discountAmount,
        };
        const url = `api/plus-membership-offers/v1/offers`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            processData: false,
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    updateDriverTipsSettings: async (driverTipsSettingsID, updates) => {
        const url = `api/product/v1/driverTipsSettings/${driverTipsSettingsID}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(updates),
        });
        return response;
    },
    updateFeatureFlag: async (featureFlagID, updates) => {
        const url = `api/product/v1/featureFlag/${featureFlagID}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(updates),
        });
        return response;
    },
    uploadFeatureFlag: async (featureFlag, wipeList, customerFile) => {
        const formData = new FormData();
        formData.append('featureFlagID', featureFlag);
        formData.append('wipeList', wipeList);
        formData.append('customerFile', customerFile);

        const url = `api/product/v1/featureFlag/customers`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    uploadLineItem: async (customerFile) => {
        const formData = new FormData();
        formData.append('customerFile', customerFile);

        const url = `api/product/v1/lineItem/customers`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
};

export { productApi };
